import React, {Component} from 'react'
import VmHeader from 'components/layout/VmHeader'
import {VmFab, VmList, VmPicker} from 'components'
import {toCurrency} from 'utils/functions'
import VmIndexRead from 'components/template/VmIndexRead'
import axios from 'axios'
import QueryString from 'qs'
import AlertYesNo from 'components/AlertYesNo'
import AlertOk from 'components/AlertOk'
import {Navigate, useNavigate, useSearchParams} from 'react-router-dom'
import {VmCheckIcon, VmPlusIcon, VmTrashIcon} from 'components/icons/solid'
import {API, graphqlOperation} from 'aws-amplify'
import {ProgressFullScreen} from 'molecules'
import {logv2} from 'utils/api-utils'
// import {
//   mAktifkanBiayaPemeriksaan,
//   mDeleteBiayaPemeriksaan,
// } from 'graphql/mutations'
const {REACT_APP_BASE_URL_UTAMA_PHP7: BASE_URL_API_UTAMA_PHP7} = process.env

class PbfPelanggan extends Component {
  fields = [
    // {key: 'index', _style: {fontWeight: 'bold'}, className: 'text-zinc-600'},
    {
      key: 'pasnama',
      // format: val => {
      //   return val
      // },
      className: 'text-zinc-600 font-bold mt-6',
    },
    {
      key: 'pasrm',
      // format: val => {
      //   return val
      // },
      className: 'text-zinc-500 ',
      type: 'icon',
      iconConfig: {
        name: 'tag',
        width: 20,
        height: 20,
        className: 'text-zinc-500',
      },
      containerClassName: '',
    },
    {
      key: 'pasalamat',
      // format: val => {
      //   return val
      // },
      className: 'text-zinc-500 font-normal ',
      type: 'icon',
      iconConfig: {
        name: 'map-pin-outline',
        width: 20,
        height: 20,
        className: 'text-zinc-500',
      },
      containerClassName: '',
    },
    {
      key: 'pastelp',
      // format: val => {
      //   return val
      // },
      className: 'text-zinc-500 font-normal ',
      type: 'icon',
      iconConfig: {
        name: 'phone',
        width: 20,
        height: 20,
        className: 'text-zinc-500',
      },
      containerClassName: 'pb-2 border-blue-500 border-b-2',
    },
  ]

  constructor(props) {
    super(props)

    this.state = {
      ubahId: 0,
      tambah: false,
      ubah: false,
      limit: 10, // Limit data per page
      data: [],
      itemsCount: 0,
      fetchingMore: false,
      gettingInitialData: true,
      hasMoreItems: true,
      device: 'mobile', // Bisa Web (Tabel) / Mobile (List)
      cari: '', // Value pencarian user
      pasaktif: 1, // Filter flag status
      pasnama: '', // Filter Nama PBF Pelanggan
      a: props.searchParams.get('a'), // appid dari PBF
      uid: props.searchParams.get('uid'), // uid dari user PBF
    }
    // console.log('constructor params', props.something)
  }

  componentDidMount() {
    // console.log('cdm', this.props.params)
    this.getInitialData()
  }

  getInitialData = () => {
    const {a, pasaktif, cari} = this.state
    // console.log({BASE_URL_API_UTAMA_PHP7})
    let limit = this.state.device == 'mobile' ? 10 : 9999 // Jika Device web, maka ambil semua data
    this.setState({gettingInitialData: true})

    // Getting Index Data
    axios
      .post(
        `${BASE_URL_API_UTAMA_PHP7}/pbf-pelanggan`,
        QueryString.stringify({
          a,
          reg: 'dbpbf',
          // cari,
          pasaktif,
          offset: 0,
          limit: 10,
          carimobile: cari,
        })
      )
      .then(({data: res}) => {
        console.log('Data PBF Pelanggan', res)

        if (!res) {
          this.setState({data: [], hasMoreItems: false})
          return
        }
        this.setState({
          data: res,
        })

        if (res.length < 10) {
          this.setState({hasMoreItems: false})
        }
      })
      .catch(err => {
        console.log(
          'Error get Data PBF Pelanggan',
          err.response?.data ?? err.message
        )
      })
      .finally(_ => {
        this.setState({gettingInitialData: false})
      })

    // Getting Count Data
    axios
      .post(
        `${BASE_URL_API_UTAMA_PHP7}/pbf-pelanggan/index-count`,
        QueryString.stringify({
          a,
          reg: 'dbpbf',
          // cari,
          pasaktif,
          carimobile: cari,
        })
      )
      .then(({data: res}) => {
        console.log('Data PBF Pelanggan count', res)

        if (!res) {
          this.setState({itemsCount: 0})
          return
        }
        this.setState({
          itemsCount: res.total,
        })
      })
      .catch(err => {
        console.log('Error get Data PBF Pelanggan count', err.message)
      })
      .finally(_ => {
        // this.setState({gettingInitialData: false})
      })
  }

  aktifkan = item => {
    const {a, uid} = this.state
    axios
      .post(
        `${BASE_URL_API_UTAMA_PHP7}/pbf-pelanggan/aktif?id=${item.pasid}`,
        QueryString.stringify({
          a,
          reg: 'dbpbf',
        })
      )
      .then(({data: res}) => {
        if (res.status != 1) {
          this.alert.show({
            message: 'Terjadi Kesalahan saat mengaktifkan Data PBF Pelanggan',
          })
          return
        }

        logv2({
          a,
          uid,
          // ip,
          reg: 'dbpbf',
          keterangan: 'Mengaktifkan pelanggan ' + res['nama'],
          menu: 'Master Data - Data Pelanggan',
          url: 'pbf-mas-kompetitor',
        })
          .then(res => {
            console.log('berhasil log', res)
          })
          .catch(e => {
            console.log('gagal log', e.response)
          })
        console.log('Berhasil aktifkan PBF Pelanggan', res)
        this.getInitialData()
      })
      .catch(err => {
        let errMsg = err.errors[0].message
        if (errMsg.includes('exit status 129')) {
          this.aktifkan(item)
        } else {
          console.log('Error mengaktifkan PBF Pelanggan', errMsg)
        }
      })
  }

  hapus = item => {
    const {a, uid} = this.state
    // console.log('onHapus gan', item)
    // return

    axios
      .post(
        `${BASE_URL_API_UTAMA_PHP7}/pbf-pelanggan/ubah?id=${item.pasid}`,
        QueryString.stringify({
          a,
          reg: 'dbpbf',
        })
      )
      .then(({data: res}) => {
        if (res && res.status != 1) {
          this.alert.show({message: res.message})
          return
        }

        // let ketcek = res['cekhapus'] == 1 ? 'Menghapus' : 'Menonaktifkan'
        logv2({
          a,
          uid,
          // ip,
          reg: 'dbpbf',
          keterangan: 'Menonaktifkan pelanggan ' + res['nama'],
          menu: 'Master Data - Data Pelanggan',
          url: 'pbf-mas-kompetitor',
        })
          .then(res => {
            console.log('berhasil log', res)
          })
          .catch(e => {
            console.log('gagal log', e.response)
          })
        console.log('Berhasil Menonaktifkan Data PBF Pelanggan', res)
        this.getInitialData()
      })
      .catch(err => {
        let errMsg = err.errors[0].message
        if (errMsg.includes('exit status 129')) {
          this.hapus(item)
        } else {
          this.alert.show({
            message:
              'Terjadi kesalahan saat menghapus data PBF Pelanggan. [BP-01]',
          })
          console.log('Error menghapus PBF Pelanggan', errMsg)
        }
      })
  }

  fetchMore = () => {
    const {a, pasaktif, cari} = this.state
    // Getting Index Data

    this.setState({fetchingMore: true})
    axios
      .post(
        `${BASE_URL_API_UTAMA_PHP7}/pbf-pelanggan`,
        QueryString.stringify({
          a,
          reg: 'dbpbf',
          carimobile: cari,
          pasaktif,
          offset: this.state.data.length,
          limit: 10,
        })
      )
      .then(({data: res}) => {
        console.log('Fetchmore Data PBF Pelanggan', res)

        // if (!res) {
        //   // this.setState({data: []})
        //   return
        // }
        if (res.length) {
          // Jika mendapatkan return data, maka append data baru ke data yang lama.
          this.setState({
            data: [...this.state.data, ...res],
          })
        }

        if (res.length < 10) {
          this.setState({hasMoreItems: false})
        }
      })
      .catch(err => {
        console.log('Error get Data PBF Pelanggan', err.message)
      })
      .finally(_ => {
        this.setState({fetchingMore: false})
      })
  }

  render() {
    const {
      data,
      itemsCount,
      hasMoreItems,
      device,
      tambah,
      ubah,
      ubahId,
      pasaktif,
      uid,
      a,
      gettingInitialData,
    } = this.state
    return (
      <>
        <ProgressFullScreen visible={gettingInitialData} />

        <AlertOk ref={ref => (this.alert = ref)} />
        <AlertYesNo ref={ref => (this.prompt = ref)} />

        {/* Component untuk navigasi */}
        {tambah ? (
          <Navigate to={`/pbf-pelanggan/tambah?a=${a}&uid=${uid}`} />
        ) : null}

        {/* Component untuk navigasi */}
        {ubah ? (
          <Navigate to={`/pbf-pelanggan/ubah/${ubahId}?a=${a}&uid=${uid}`} />
        ) : null}

        <VmIndexRead
          headerTitle={'Data PBF Pelanggan'}
          items={data}
          itemsCount={itemsCount}
          fields={this.fields}
          listItemContainerClassName={'p-4 border shadow-lg m-4 rounded'}
          listSearchbar={{placeholder: 'Cari Nama PBF Pelanggan'}}
          // listSearchbarLeft={<p>Test halo</p>}
          listSearchbarRight={
            <VmPicker
              style={{
                // flex: 0.2,
                background:
                  'url(https://cdn-icons-png.flaticon.com/512/32/32195.png) var(--sizeIco) no-repeat #FFF',
                // paddingRight: '4px !important',
                paddingLeft: 4,
              }}
              items={[
                {value: 1, text: 'Aktif'},
                {value: 2, text: 'Tidak Aktif'},
              ]}
              onChange={e => {
                let val = e.target.value
                this.setState(
                  {pasaktif: val, hasMoreItems: true},
                  this.getInitialData
                )
                // console.log('onChange gan', val)
              }}
              placeholder={null}
              value={pasaktif}
              className="rounded-xl text-sm mb-2 py-2 #ffffff"
            />
          }
          listSearchbarClassname="" // Class Untuk inputan filter search bar
          onItemPress={item => {}}
          editButton={item => {
            // Menampilkan button hanya untuk data yang pasaktif == 1
            return item.pasaktif == 1 || item.pasaktif == -1
          }}
          deleteButton={item => {
            // Menampilkan button hanya untuk data yang pasaktif == 1
            return item.pasaktif == 1 || item.pasaktif == -1
          }}
          customButton={item => {
            // Menampilkan button hanya untuk data yang pasaktif != 1 ()
            if (item.pasaktif == 1 || item.pasaktif == -1) {
              return (
                <div
                  onClick={() => {
                    // Arahkan ke Halaman CRUD Apoteker Pelanggan gan.
                    this.props.navigate(
                      `/pbf-apoteker?a=${a}&uid=${uid}&pasid=${item.pasid}`
                    )
                  }}
                  className="flex flex-1 items-center justify-center rounded bg-white ml-2 py-1"
                >
                  <VmPlusIcon
                    height={`${24}px`}
                    width={`${24}px`}
                    className="text-green-500"
                  />
                  <p className="text-green-500">Tambah Apoteker</p>
                </div>
              )
            }

            // Tampilkan tombol untuk aktifkan Pelanggan
            return (
              <div
                onClick={() => {
                  this.aktifkan(item)
                }}
                className="flex flex-1 items-center justify-center rounded bg-white ml-2 py-1"
              >
                <VmCheckIcon
                  height={`${24}px`}
                  width={`${24}px`}
                  className="text-green-500"
                />
                <p className="text-green-500">Aktifkan</p>
              </div>
            )
          }}
          onEditItemPress={item => {
            this.setState({ubahId: item.pasid, ubah: true})
          }}
          onDeleteItemPress={item => {
            this.prompt.show(
              {message: `Apakah anda yakin ingin menghapus ${item.pasnama}?`},
              () => {
                this.hapus(item)
              }
            )
          }}
          // Start List Props
          hasMoreItems={hasMoreItems}
          loadMore={() => {
            // Jika sedang load new data / Get initial data maka ndak perlu panggil fetchMore lagi (Antisipasi data ndobel)
            if (!this.state.fetchingMore && !this.state.gettingInitialData)
              this.fetchMore()
          }}
          // End List Props
          // Start Table Props

          // End Table Props
          onFabPress={() => {
            // console.log('Fab Press')
            // redirect('/pbf-pelanggan/tambah')
            this.setState({tambah: true})
          }}
          device={device}
          onSearchSubmit={value => {
            this.setState(
              {cari: value, hasMoreItems: true},
              this.getInitialData
            )
          }}
        />
      </>
    )
  }
}

function withParams(Component) {
  return props => {
    const [searchParams, setSearchParams] = useSearchParams()
    const navigate = useNavigate()
    // console.log('withParams', searchParams)
    return (
      <Component {...props} navigate={navigate} searchParams={searchParams} />
    )
  }
}

function withSomething(Component) {
  return props => <Component {...props} something="something" />
}

export default withSomething(withParams(PbfPelanggan))
